import { getTypedState } from 'ducks/hooks'
import { Subscription } from 'ducks/types'
import { isEmpty } from 'helpers/index'
import { OrderMaintenanceType } from './types'

export const getOrderMaintenanceStep = () => (): any => {
  const { newEstimate } = getTypedState() || {}
  return newEstimate?.step || 0
}

export const getOrderMaintenanceValue = (type: keyof OrderMaintenanceType) => (): any => {
  const { orderMaintenance } = getTypedState()
  // if (!orderMaintenance) return null
  return orderMaintenance[type as keyof OrderMaintenanceType]
}

export const getOrderMaintenanceValues = () => (): OrderMaintenanceType => {
  const { orderMaintenance } = getTypedState()
  return orderMaintenance
}

export const getOrderMaintenanceToCreate = () => (): Partial<Subscription> => {
  const { orderMaintenance } = getTypedState()
  const { step, mobileStep, contractSigned, promo, homeownerReceives, ...rest } = orderMaintenance
  if (isEmpty(promo)) {
    rest.promoCode = null
  }
  return Object.fromEntries(Object.entries(rest)?.filter(([_, v]) => v));
}